import { useState, useEffect } from 'react';

export const useVisibilityElement = (targetId, margin = 0) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const targetElement = document.getElementById(targetId);
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { rootMargin: `-${margin}px 0px -${margin}px 0px`, threshold: [0] },
    );

    if (targetElement) {
      observer.observe(targetElement);
    }

    return () => {
      if (targetElement) {
        observer.unobserve(targetElement);
      }
    };
  }, [targetId]);

  return { isVisible };
};
